import Vue from "vue";
export default {
  archiveFeedback(_, id) {
    return Vue.$http.post(`/hrm/surveys/${id}/archive`);
  },
  restoreFeedback(_, id) {
    return Vue.$http.post(`/hrm/surveys/${id}/restore`);
  },
  deleteArchivedFeedback(_, id) {
    return Vue.$http.delete(`/hrm/surveys/${id}`);
  },
  addFeedbackSurvey(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`hrm/surveys`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateFeedbackSurvey(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`hrm/surveys`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleSizeChangeFeedbackSurvey({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAllFeedbackSurvey");
  },
  handleCurrentChangeFeedbackSurvey({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllFeedbackSurvey");
  },
  getAllFeedbackSurvey({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const archived = state.archived;

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        archived,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/surveys", { params })
        .then(response => {
          if (state.archived === archived) {
            commit("allFeedbackSurvey", response.data.results);
            commit("paginationTotal", response.data.total);
            commit("tableLoading", false);
          }
          resolve(response.data);
        })
        .catch(error => {
          if (state.archived === archived) commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  feedbackGetSurveyAnswers({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/surveys/get-survey-answers?id=${id}`)
        .then(response => {
          commit("setSurveyAnswers", response.data[0]);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteFeedbackAnswers(_, { surveyId, answeredById, answeredForId }) {
    return Vue.$http.delete(`/hrm/surveys/${surveyId}/answers`, {
      params: {
        answered_by_id: answeredById,
        answered_for_id: answeredForId,
      },
    });
  },
  getFeedbackSurveyById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/surveys/${id}`)
        .then(response => {
          commit("setSelectedRow", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editFeedbackSurvery(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`hrm/surveys`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteBenefitAndDeductionType(_, ids) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(
          `payroll/benefit-and-deduction/settings/benefit-deduction-types/[${ids}]`
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
